import { workdayLabelMap } from "@lib/logic";
import { WorkdayHeaderTitle } from "src/components/organisms/calendar/WorkdayTile/WorkdayTileHeader";
import { WorkdayIcon } from "@molecules";
import { useTranslation } from "react-i18next";

export const UserScheduleUnknownWorkdayTile = () => {
  const { t } = useTranslation();

  return (
    <div className="p-4 rounded-xl border border-gray-200 bg-beige-200">
      <div className="flex items-center p-1.5 gap-4 w-full">
        <WorkdayIcon
          status={"Unknown"}
          className="bg-energizing-yellow-500*"
        />

        <div>
          <WorkdayHeaderTitle title={t(workdayLabelMap["Unknown"])} />
        </div>
      </div>
    </div>
  );
};
